import { gql } from '@apollo/client';

export const DOMAIN_RATES_QUERY = gql`
  query DomainRates($id: Int!) {
    domainById(id: $id) {
      id
      name
      draperyCutLaborCost
      rateDrapeInstallPerFt
      rateDrapeInstallMin
      rateHospitalTrackPerFt
      liningRegularCost
      liningBlackoutCost
      liningSheerCost
      interliningBumpCost
      interliningFlannelCost
      draperyTrimLaborCostPerYard
      draperyCtmHardwareCost
      romanShadeLaborCostPerSqFt
      romanShadeInstallPerWidth
      romanShadeInstallMin
      romanShadeBoardSmallCost
      romanShadeBoardLargeCost
      romanShadeVelcroCostPerYard
      romanShadeTrimLaborCostPerYard
      romanShadeCordCleatCost
      romanShadeRolleaseCost
      romanShadeSomfyCost
      rateValanceInstallPerFt
      rateValanceInstallMin
      ratePleatedFabPerCut
      shirredValanceFabPerCut
      shirredValanceInstallPerFt
      shirredValanceInstallMin
      shirredValanceBoardSmallCost
      shirredValanceBoardLargeCost
      shirredValanceVelcroCostPerYard
      shirredValanceTrimLaborCostPerYard
      rateBalloonFabPerSqft
      rateAustrianFabPerSqft
      rollerShadeFabricationNarrowCost
      rollerShadeFabricationWideCost
      rollerShadeInstallationCost
      rollerShadeSmallRodPerFootCost
      rollerShadeMediumRodPerFootCost
      rollerShadeHeavyRodPerFootCost
      rollerShadeSmallClutchAndIdleEndSetCost
      rollerShadeMediumClutchAndIdleEndSetCost
      rollerShadeLargeClutchAndIdleEndSetCost
      rollerShadeExtraClutchAndIdleEndSetCost
      rollerShadeWandMotorCost
      rollerShadeBottomBarStandardPerFootCost
      rollerShadeBottomBarBlackoutPerFootCost
      rollerShadeFasciaPerFoot3InCost
      rollerShadeFasciaPerFoot4InCost
      rollerShadeFasciaBrackets3InCost
      rollerShadeFasciaBrackets4InCost
      rollerShadeEndcapsStandardCost
      rollerShadeEndcapsBlackoutCost
      rollerShadeChainsCoversCost
      rollerShadeTapeCost
      rollerShadeShippingCost
      rollerShadeRetailPriceMarkup
      rollerShadeCustomWoodFasciaCostPerFoot
      rateSomfyMotor
      rateRolleaseMotor
      rateTrimLaborPerYd
      rateVelcroPerYd
      rateDelivery
      ratePillowZipper
      rateBolsterZipper
      rateCushionZipperShort
      rateCushionZipperLong
      rateCushionLaborThin
      rateCushionLaborThick
      rateCushionInsertDacron
      rateCushionInsertDownWrap
      rateCushionInsertDown
      rateDuvetZipper
      rateMeasureCharge
    }
  }
`;

export const UPDATE_DOMAIN_RATES_MUTATION = gql`
  mutation UpdateDomainRates($id: Int!, $patch: DomainPatch!) {
    updateDomainById(input: { id: $id, domainPatch: $patch }) {
      domain {
        id
      }
    }
  }
`;
